
import Lydia from "../static/images/sectionTalking/2024/Lydia_color.jpg";
import Lydia1 from "../static/images/sectionTalking/2024/Lydia_pbw.png";      
import Tim from "../static/images/sectionTalking/2024/Tim_color.jpg";
import Tim1 from "../static/images/sectionTalking/2024/Tim_pbw.png";
import Camille from "../static/images/sectionTalking/2024/Camille_color.jpg";
import Camille1 from "../static/images/sectionTalking/2024/Camille_pbw.png";
import Billy from "../static/images/sectionTalking/2024/Billy_color.jpg";
import Billy1 from "../static/images/sectionTalking/2024/Billy_pbw.png";


export default [
    {
      name: "Lydia",
      position: "Business Development Intern",
      img: Lydia1,
      photo: Lydia,
      article: `
  <p>嗨～我是 Lydia，是 SurveyCake BD 的實習生！</p>
  <p>這次的實習對我來說是一個充滿挑戰與成長的旅程，從剛開始對 BD 工作與產品功能一知半解還糊理糊塗的，到後來逐漸能在每次與客戶的會議中釐清需求與相應的解決方案規劃，再後來獨立負責直接與客戶溝通並且協助完成專案，這些過程都是在新芽中的收穫。在實習期間遇到任何問題，大家也都超有耐心提供幫助和指導！（在各方面真的都受到大家超多幫忙！❤️）</p>
  <p>作為一個 BD intern，我主要的工作涵蓋參與客戶會議、撰寫會後信、帳號建置、依客戶需求協助製作問卷、處理客戶文件、協助客戶交接、對外 webinar 簡報製作、每月月報數據整理等多元工作內容，目前八個多月的時間，也累積參與 50 場以上不同產業的客戶會議，在過程中更熟悉 SurveyCake 不同產品與功能如何提供給客戶的解決方案，也更了解身為一個 BD 如何有效率地進行內外溝通與 multitasking 的工作能力。除了可以完整參與正職 BD 的實際工作，也會有與不同部門合作的機會，例如參與跨部門會議與後期協助 PM 團隊進行產品測試，更直接接觸產品更新與優化流程，全面了解公司的成長規劃。</p>
  <p>最後，新芽在工作環境和福利上都很讚，除了可以彈性選擇遠端工作，在任務執行上也給實習生自主發揮的空間，整體氣氛也非常快樂，推薦給想進入新創軟體業或有志於 BD 工作的夥伴一起在團隊中成長🌱</p>
  `
    },
    {
      name: "Tim",
      position: "Project Management Intern",
      img: Tim1,
      photo: Tim,
      article: `
  <p>大家好，我是 PM intern Tim！🌱</p>
  <p>在新芽擔任 PM intern 的這段時間，我獲得了許多寶貴的實戰經驗，而這一切都要感謝新芽主管們的耐心指導與支持，讓我能夠快速成長，深入了解專案經理的職責與價值。</p>
  <p>從客戶例會到內部協作，我學習到如何即時記錄會議重點、整理需求與結論，並運用 AI 輔助摘要來提高資訊傳遞的效率。在與工程師合作的過程中，我負責確認開單規格、評估 due date、釐清測試問題並跟進修復，確保專案順利推進。同時，在主管們的指導下，我參與了 E2E 測試、 test case 設計與 UI 規格盤點，學會如何站在使用者角度思考各種情境，確保產品穩定性。透過實際開單的練習，我也逐步培養出盤點會議紀錄、確認現行規格、發想初步方案的習慣，並利用 wireframe 與截圖等視覺輔助工具，讓工程師能更直觀理解需求。此外，在專案排程方面，我也學習到如何根據人力與時程評估任務優先級，確保進度既靈活又可行。</p>
  <p>這些能力與經驗的累積，離不開新芽主管們悉心的指導與分享，他們不僅耐心解答疑問，還提供了許多實務建議，幫助我更快進入狀況並掌握專案管理的核心能力。這段實習經驗讓我更加確信，未來我會持續朝軟體 PM 的方向發展，並將所學帶向下一個階段！</p>
  `
    },
    {
      name: "Camille",
      position: "Product Management Intern",
      img: Camille1,
      photo: Camille,
      article: `
  <p>Hi ，我是 SurveyCake 的 PM 實習生 Camille！</p>
  <p>還記得當初收到 Job Offer 時超級開心又興奮，很高興自己能夠來到傳說中自由、開放又溫暖的新芽。在實習期間，我受到了各方的照顧，無論是正職的產品經理還是開發團隊，都非常耐心地回答各種問題，並一步一步帶我熟悉軟體開發與產品管理領域。</p>
  <p>在過程中，我主要負責協助產品測試、幫忙排查問題、進行競品研究以及參與規格討論。這些工作都是我進入新芽後，跟隨正職夥伴們逐步學習的，包括如何初步排查 bug、撰寫有組織的規格以及更有效率地與前後端溝通，對此我充滿感激。</p>
  <p>去年年末，我參加了公司的 outing，與 BU head 以及老闆一起見證了公司、產品的前景與 roadmap，真的很慶幸能在這裡一起見證這個時刻。</p>
  <p>如果你不怕面對挑戰、喜歡溫暖且彈性的工作環境，那這裡一定很適合你！一起加入新芽這個溫馨大家庭吧～</p>
  `
    },
    {
      name: "Billy",
      position: "Quality Assurance Engineer Intern",
      img: Billy1,
      photo: Billy,
      article: `
  <p>Hi 大家好，我是新芽 SurveyCake QA Engineer Intern 的實習生 Billy。</p>
  <p>我主要負責 SurveyCake 的 E2E 自動化測試，這讓我對測試有了全新的認識與體會。以往在學校課堂上，我們較少接觸到完整的測試流程；但在新芽實習期間，我學會了如何設計有效的測試案例，包括驗證表單輸入、檢查 UI 元素等實務操作，同時也學會使用版本控制系統與其他工程師協作，並透過 CI/CD pipeline 自動化測試流程。</p>
  <p>在測試過程中，我發現 QA 工作需要非常強的邏輯思維與細節觀察能力，不僅要測試正常情況，還要考慮各種邊界條件和異常情況，每個測試案例都必須仔細規劃，兼顧各種使用情境。</p>
  <p>新芽的工作環境非常開放且支持學習，團隊中的前輩們都樂於分享經驗，讓我在遇到問題時能夠迅速學習和成長。無論是蛋糕開發團隊還是產品團隊，大家都願意花時間解答我的疑問，讓我能更全面地理解產品開發流程。辦公室環境輕鬆活潑，這也是我非常喜歡公司的原因之一。對於想進入 QA 領域的同學，新芽絕對是一個能夠真正動手實作並培養專業能力的好地方。在這裡，你不只是在寫測試，更是在參與打造一個優質產品的過程，歡迎你來嘗試！</p>
  `
    }
  ]
  
  


// WEBPACK FOOTER //
// ./src/models/Sprouters2024.js